import Permissions from '../constants/permissions';

const routes = [
  {
    path: '/dam',
    name: '',
    component: () => import('../layouts/Layout'),
    children: [
      {
        path: 'assets',
        name: 'damAssets',
        component: () => import('../views/Assets'),
        meta: {
          permission: Permissions.Pages.ASSETS,
        },
      },
      {
        path: 'dashboard',
        name: 'damDashboard',
        component: () => import('../views/Dashboard'),
        meta: {
          permission: Permissions.Pages.DASHBOARD,
          fail: '/dam/assets',
        },
      },
      {
        path: 'error',
        name: 'dam-error',
        component: () => import('../views/DamError'),
        meta: {},
      },
      // LEGACY ROUTE
      {
        path: '',
        redirect: {
          name: 'damDashboard',
        },
      },
    ],
  },
];

export default routes;
